<template>
  <div>
    <form
      v-if="isLoaded"
      @submit.prevent="editPush"
    >

      <h3 class="mb-3">
        Image url
      </h3>

      <div class="form-group">
        <label for="player-ids"><i>(root is {{imageUrlRoot}})</i></label>
        <b-icon icon="question-circle" v-b-popover.hover.right="'To add an image, specify its name, otherwise the default will be used'"></b-icon>
        <input
            v-model="imageUrl"
            id="imageUrl"
            class="form-control"
            placeholder="Enter image url like 'common.jpg'" >
      </div>

      <text-variant-input
        v-for="textVariant in textVariants"
        :key="textVariant.lang"
        :textVariant="textVariant"
        ref="textVariantInput"
        class="mb-3"
      />

      <b-button :to="{name: 'push_info', params: {pushId: pushId}}">Cancel</b-button>
      <b-button type="submit" variant="primary">Save</b-button>

    </form>
  </div>
</template>

<script>
import notifier from '../notifier';
import { HTTP } from '../http-common';

import { createTextVariants } from '../model/push';

import TextVariantInput from './PushTextVariantInput.vue';
import {HTTP_RESOURCES_ROOT} from "@/autogen/settings";

export default {
  components: {
    TextVariantInput,
  },

  name: 'PushEdit',

  props: {
    pushId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      textVariants: null,
      imageUrl: "",
      imageUrlRoot: "/assets/notifications/",
    };
  },

  computed: {
    isLoaded() {
      return this.textVariants !== null;
    }
  },

  created() {
    HTTP.get('/push/get_payload/' + this.pushId)
    .then(response => {
      this.textVariants = response.data.textVariants;
      let url = response.data.imageUrl;
      this.imageUrl = url.split(HTTP_RESOURCES_ROOT + this.imageUrlRoot)[1]
      console.log(this.imageUrl)
    })
    .catch(e => {
      notifier.showError(e.response.data, {sender: this});
    });
  },

  methods: {
    editPush() {
      const url = '/push/edit/' + this.pushId;
      const payload = {
        textVariants: this.getTextVariants(),
        imageUrl: this.imageUrlRoot + this.imageUrl
      }

      HTTP.post(url, payload)
      .then(() => {
        notifier.showSuccessAfterTransition('Changes saved.');
        this.$router.push({name: 'push_info', params: {pushId: this.pushId}});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      })
    },

    getTextVariants() {
      const textVariantInputs = this.$refs.textVariantInput;
      return createTextVariants(textVariantInputs);
    },
  }
}

</script>
